import { render, staticRenderFns } from "./PrimaryFooter.vue?vue&type=template&id=dfabdada&"
import script from "./PrimaryFooter.vue?vue&type=script&lang=js&"
export * from "./PrimaryFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports